import React from 'react';
import { Bell, CircleHelp, User } from 'lucide-react'; // Import icons

const Header: React.FC = () => {
  // Updated header content and styling based on the screenshot
  return (
    <header style={{
      display: 'flex',
      alignItems: 'center', // Vertically align items
      justifyContent: 'space-between',
      padding: '16px 24px', // Adjust padding based on visual inspection
      borderBottom: '1px solid #e2e8f0', // Light gray border
      backgroundColor: '#ffffff', // White background
    }}>
      {/* Search Input - Style needed */}
      <input
        type="search"
        placeholder="Search"
        style={{
          padding: '8px 12px',
          border: '1px solid #cbd5e1', // Gray border
          borderRadius: '6px', // Rounded corners
          width: '300px', // Adjust width as needed
        }}
      />
      {/* Icons Container */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}> {/* Increased gap slightly */}
        {/* Replace spans with Lucide icons */}
        <Bell size={20} strokeWidth={1.5} style={{ cursor: 'pointer', color: '#64748b' }} /> {/* Notification Icon */}
        <CircleHelp size={20} strokeWidth={1.5} style={{ cursor: 'pointer', color: '#64748b' }} /> {/* Help Icon */}
        <User size={20} strokeWidth={1.5} style={{ cursor: 'pointer', color: '#64748b' }} /> {/* User Icon */}
      </div>
    </header>
  );
};

export default Header; 